// SolarSystemProductPageComponent.jsx

import React, { useState } from "react";
import "../ProductPage/CSS/SolarSystemProductPageComponent.css";

import img1 from "../ProductPage/Images/solar.png";
import img2 from "../ProductPage/Images/inverter.png";
import img3 from "../ProductPage/Images/battery.png";
import img4 from "../ProductPage/Images/controller.png";
import img5 from "../ProductPage/Images/mounting.png";
import img6 from "../ProductPage/Images/accessories.png";

const components = [
  {
    id: 1,
    title: "Solar Panels",
    short: "Solar Panel",
    image: img1,
    description:
      "Capture sunlight using photovoltaic (PV) cells and convert it into direct current (DC) electricity. They are the primary source of energy generation in the system and perform best with proper sunlight exposure.",
    cardText:
      "Convert sunlight into electricity using high-efficiency photovoltaic technology for maximum energy generation.",
    color: "#040216",
    bottomBg: "#040216",
  },

  {
    id: 2,
    title: "Inverter",
    short: "Inverter",
    image: img2,
    description:
      "Transforms the DC electricity generated by solar panels into alternating current (AC), which is used to power household appliances. It acts as the core system that makes solar energy usable.",
    cardText:
      "Converts DC power into usable AC electricity, making it compatible with all your home appliances. ",
    color: "#111",
    bottomBg: "#111",
  },

  {
    id: 3,
    title: "Batteries",
    short: "Batteries",
    image: img3,
    description:
      "Store excess electricity generated during the day for use at night or during power outages. They ensure a continuous and reliable power supply even when sunlight is unavailable.",
    cardText:
      "Store excess energy generated during the day for reliable use at night or during power outages. ",
    color: "#072A1D",
    bottomBg: "#072A1D",
  },

  {
    id: 4,
    title: "Charge Controller",
    short: "Charge Controller",
    image: img4,
    description:
      "Regulates the flow of electricity between solar panels, batteries, and inverter. It protects the batteries from overcharging or deep discharge, increasing their lifespan and efficiency.",
    cardText:
      "Regulates and Manages power flow to protect batteries and ensure optimal system performance. ",
    color: "#8D3C10",
    bottomBg: "#8D3C10",
  },

  {
    id: 5,
    title: "Mounting Structure",
    short: "Mounting",
    image: img5,
    description:
      "Provides a strong and stable foundation for installing solar panels. It ensures the panels are positioned at the optimal angle to capture maximum sunlight throughout the day.",
    cardText:
      "Provides strong support and ensures the panels are positioned at the optimal angle for maximum sunlight exposure.",
    color: "#818084",
    bottomBg: "#818084",
  },

  {
    id: 6,
    title: "Accessories",
    short: "Accessories",
    image: img6,
    description:
      "Includes essential components like cables, connectors, combiner boxes, earthing systems, and safety devices. These elements ensure safe operation, proper wiring, and overall system reliability.",
    cardText:
      "Includes essential safety devices, wiring, and connectors of secure and efficient system operation. ",
    color: "#373737",
    bottomBg: "#373737",
  },
];

const SolarSystemProductPageComponent = () => {
  const [active, setActive] = useState(1);

  return (
    <section className="SolarSystemProductPageComponent-section">
      <div className="SolarSystemProductPageComponent-container">
        {/* LEFT SIDE */}

        <div className="SolarSystemProductPageComponent-cards-wrapper">
          {components.map((item) => (
            <div
              key={item.id}
              className={`SolarSystemProductPageComponent-card ${
                active === item.id
                  ? "SolarSystemProductPageComponent-active-card"
                  : ""
              }`}
              style={{
                background: item.color,
              }}
              onClick={() => setActive(item.id)}
            >
              {active === item.id ? (
                <>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="SolarSystemProductPageComponent-image"
                  />

                  <div className="SolarSystemProductPageComponent-overlay"></div>

                  <div className="SolarSystemProductPageComponent-active-content">
                    <p>{item.cardText}</p>

                    <h4
                      style={{
                        background: item.bottomBg,
                      }}
                    >
                      {item.short}
                    </h4>
                  </div>
                </>
              ) : (
                <div className="SolarSystemProductPageComponent-vertical-text">
                  {item.short}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* RIGHT SIDE */}

        <div className="SolarSystemProductPageComponent-content">
          <h2>Key Components Of System</h2>

          <div className="SolarSystemProductPageComponent-content-details">
            <h3>{components.find((item) => item.id === active).title}</h3>

            <p>{components.find((item) => item.id === active).description}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolarSystemProductPageComponent;
